/*
 * @Author: hzm
 * @Date: 2022-12-14 11:01:27
 * @Description:
 */

import { listTaskForUser } from '@/api/todoTask';
import { defineStore } from 'pinia';

export const useTaskStore = defineStore('task', {
  state: () => ({
    taskNotHandelCount: 0,
    taskNotHandelList: [],
  }),
  getters: {},
  actions: {
    getUserNotHandelTaskList(queryParams) {
      const self = this;
      return new Promise((resolve, reject) => {
        listTaskForUser({
          pageNum: 1,
          pageSize: 5,
          status: 0,
          ...queryParams,
        }).then(res => {
          this.taskNotHandelCount = res.total;
          this.taskNotHandelList = (res?.rows ?? []).splice(0, 5);
          resolve(res);
        });
      });
    },
  },
});
